import {
    Category,
    CategoryWithProducts,
    CategoryWithSubCategories,
    CreateCategoryBody,
    CreateSubCategoryBody,
    SubCategory,
} from '@core/models/category.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class CategoryService {
    private readonly getCategoriesWithSubURL = `/category/get_category_with_sub`;
    private readonly getCategoriesURL = `/category/get_category`;
    private readonly addCategoryURL = `/category/add_category`;
    private readonly getCategoryWithSubByIdURL = `/category/get_category_with_sub_by_id`;
    private readonly getCategoryByIdWithProductsURL = `/category/get_category_by_id`;
    private readonly getSubCategoriesURL = `/sub_category/get_sub_category`;
    private readonly addSubCategoryURL = `/sub_category/add_sub_category`;
    private readonly getSubCategoryByIdURL = `/sub_category/get_sub_category_by_id`;

    // ---------------------------------------------------------------

    getCategoriesWithSub() {
        return fetchWithRetry(API.get<CategoryWithSubCategories>(this.getCategoriesWithSubURL));
    }

    getCategories() {
        return fetchWithRetry(API.get<Category[]>(this.getCategoriesURL));
    }

    addCategory(body: CreateCategoryBody) {
        return fetchWithRetry(API.post(this.addCategoryURL, body));
    }

    getCategoryWithSubById(id: number) {
        return fetchWithRetry(API.get<CategoryWithSubCategories>(`${this.getCategoryWithSubByIdURL}/${id}`));
    }

    getCategoryByIdWithProducts(id: number, params?: { num?: number; productSize?: number }) {
        return fetchWithRetry(
            API.get<CategoryWithProducts>(`${this.getCategoryByIdWithProductsURL}/${id}/products`, { params })
        );
    }

    getSubCategories() {
        return fetchWithRetry(API.get<SubCategory[]>(this.getSubCategoriesURL));
    }

    addSubCategory(body: CreateSubCategoryBody) {
        return fetchWithRetry(API.post(this.addSubCategoryURL, body));
    }

    getSubCategoryById(id: number, params?: { page?: number; productSize?: number }) {
        return fetchWithRetry(API.get<SubCategory>(`${this.getSubCategoryByIdURL}/${id}`, { params }));
    }
}

export default new CategoryService();
